import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { GbeEndPointV4 } from '@core/models/gbe/gbe-endpoint.enum';
import { GBE_BASE_URL } from '@core/tokens/gbe-url.token';

interface ActiveFeaturesResponse {
  activeFeatures?: string[];
}

@Injectable({ providedIn: 'root' })
export class FeatureFlagsService {
  private readonly gbeUrl = inject(GBE_BASE_URL);
  private readonly http = inject(HttpClient);

  private buildUrl(path: string): string {
    return `${this.gbeUrl}/${path}`;
  }

  listActiveFeatures$(dataSpaceId?: number): Observable<string[]> {
    return this.http
      .get<ActiveFeaturesResponse>(this.buildUrl(GbeEndPointV4.FEATURE_FLAGS), {
        params: dataSpaceId != null ? { data_space_id: dataSpaceId } : {}
      })
      .pipe(map((response) => response.activeFeatures ?? []));
  }
}
